module.exports = __webpack_public_path__ + "static/media/plane.e35f35cd.svg";